export enum EnumBenefitInsurancePlanState {
  ACTIVE = "active",
  PENDING_REVIEW = "pending_review",
  REJECTED = "rejected",
  CANCELING_REVIEW = "canceling_review",
  REFUNDED = "refunded",
  INACTIVE = "inactive",
  PENDING_RENEWAL = "pending_renewal",
  WAITING = "waiting",
  CANCELED = "canceled",
  OVER_DUE = "over_due",
}

export enum EnumPassiveBenefitInsurancePlanState {
  DRAFT = "draft",
  FAILED = "failed",
}
